import CHECKOUT_ERRORS from '../constants/checkout-error-enums';
import getCheckoutMessage from './get-checkout-message';
import isPhone from './is-phone';
import validateConsumerObject from './validate-consumer-object';

/**
 * processConsumerObject
 * @param {object} data
 * @return {boolean} is consumer obj valid?
 */
const isConsumerObjectValid = ({ consumer, dataLayer, pId }) => {
  // validate consumer object with Joi; will return `null` if valid
  const consumerObjectError = validateConsumerObject(consumer);
  let phoneError;
  const consumerPhoneNumber = consumer?.mobileNumber?.phoneNumber ?? '';
  const consumerCountryCode = consumer?.mobileNumber?.countryCode ?? '';
  // validate phone only when it's passed in
  if (consumerPhoneNumber) {
    phoneError = !isPhone(consumerPhoneNumber, consumerCountryCode);
  }
  let message;
  if (consumerObjectError) {
    message = getCheckoutMessage({ dataLayer, error: consumerObjectError, pId });
  } else if (phoneError) {
    message = getCheckoutMessage({
      dataLayer,
      error: { reason: CHECKOUT_ERRORS.INVALID_PARAMETER },
      pId
    });
  }
  return message;
};
export default isConsumerObjectValid;
